/**
 * Utility functions for resolving navigation preference state.
 */

/**
 * Resolves the effective nav preference.
 *
 * @param userNavPreference - The value from user.getSetting('use_new_primary_nav')
 * @param showNewPrimaryNav - The account-level flag value (defaults to false if undefined)
 * @returns Whether to use the new navigation (V2)
 */
export function resolveNavPreference(
  userNavPreference: boolean | undefined,
  showNewPrimaryNav: boolean | undefined,
): boolean {
  // If there's an explicit user preference, use it; otherwise fall back to account flag (default false)
  return userNavPreference ?? showNewPrimaryNav ?? false;
}

/**
 * Resolves the effective dismiss state.
 *
 * @param userDismissSetting - The value from user.getSetting('dismiss_new_navigation')
 * @returns Whether the nav toggle should be dismissed
 */
export function resolveDismiss(userDismissSetting: boolean | undefined): boolean {
  return userDismissSetting ?? false;
}
